"use client";

import * as React from "react";

import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { cn } from "../../lib/utils";
import { HoverCardClickable } from "./HoverCardClickable";

interface FeatureIconsProps {
  tooltipText: string;
  numRelated: number;
  hoverDelay?: number;
  onClickText?: string;
  side?: "top" | "bottom" | "left" | "right";
  iconSize?: number;
  className?: string;
  showArrow?: boolean;
  iconClassName?: string;
}

export const FeatureIcons = React.forwardRef<HTMLDivElement, FeatureIconsProps>(
  ({ tooltipText, numRelated, side = "bottom", iconSize = 16, className, iconClassName = "", showArrow = false, hoverDelay = 600, onClickText }, ref) => {
    // No related fields: render nothing at all. Previously this still mounted a
    // HoverCardClickable whose trigger collapsed to an invisible-but-interactive <span> —
    // an empty hover target and a live Popper anchor on every field label for no reason.
    if (numRelated <= 0) return null;
    return (
      <HoverCardClickable
        side={side}
        triggerJSX={
          numRelated === 1 ? (
            <KeyboardArrowRightIcon sx={{ fontSize: iconSize }} className={iconClassName} />
          ) : (
            <KeyboardDoubleArrowRightIcon sx={{ fontSize: iconSize }} className={iconClassName} />
          )
        }
        className={cn("text-tertiary-dark hover:text-skyBlue", className)}
      >
        <div className="px-2 py-1 text-sm text-primary-dark">{tooltipText}</div>
      </HoverCardClickable>
    );
  }
);
FeatureIcons.displayName = "FeatureIcons";
